import { COMPANY_ROUTE } from '@constants'

export const API_COMPANY_ONBOARDING_TASKS_URL = `${COMPANY_ROUTE}autotax-onboarding/`
export const API_COMPANY_REPORT_URL = `${COMPANY_ROUTE}report/`
export const API_COMPANY_VAT_POSITION_REPORT_URL = `${COMPANY_ROUTE}report/vat-position`
export const API_COMPANY_BANK_TRANSACTIONS_REPORT_URL = `${COMPANY_ROUTE}report/bank-transactions/`
